import axios from 'axios'
import { useTokenInterceptor } from 'interceptors/tokenInterceptor'

export const apiV2 = axios.create({
  baseURL: process.env.REACT_APP_API_V2,
})

apiV2.interceptors.request.use(useTokenInterceptor)
